
import { i18nText } from '@/locales';

import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {Component} from "vue-property-decorator";
import {SimpleProxyForm} from "@/UI/components/Helpers/SimpleProxyForm";
import {mixins} from "vue-class-component";
import {Col, Result, Row} from "ant-design-vue";
import {ProductsMix} from "@/UI/mixins/Store/ProductsMix";
import {DataEntity} from "@/entity/warehouse/Products/Products.types";
import {OperationsStore} from "@/store/modules/Warehouse/Operations";
import Login from "../../auth/Login.vue";

@Component({
  components: {
    BaseDataForm,
    "a-col": Col,
    "a-row": Row,
    "a-result": Result,
  },
})
export default class ReportForm extends mixins(SimpleProxyForm, ProductsMix) {
  formData = JSON.parse(this.$route.params["Data"]);
  productData: Array<DataEntity> = [];
  linkCaption = i18nText("< Вернуться назад");
  summProducts = 0;
  form_data: any = []
  mod = this.$route.params['mod']

  async getProductName(id: number): Promise<void> {
    await this.productById(id);
  }

  calcSum(): number {
    let sData = 0
    if (this.mod === '1') {
      if (this.form_data[0].products) {
        this.form_data[0].products.forEach((value: any) => {
          let sum = value.price * value.quantity
          sData = sData += sum - Number(value["quantity"]) * Number(value["price"]) * Number(value["discount"]) / 100
        })
      }
    } else {
      if (this.formData.products) {
        this.formData.products.forEach((product: any) => {
          let sum = Number(product["price"]) * Number(product["quantity"])
          sData = sData += sum - Number(product["quantity"]) * Number(product["price"]) * Number(product["discount"]) / 100
        })
      }
    }
    return sData
  }

  async created(): Promise<void> {
    this.formReady = false;
    try {
      let data = JSON.parse(this.$route.params["Data"]);
      await OperationsStore.fetchAll({filter: {id: data.id}})
      this.form_data = OperationsStore.operations?.data
      if (!this.form_data.length) {
        this.form_data = this.formData;
      }

      if (this.formData.products) {
        this.formData.products.forEach((key: any) => {
          this.productById(key["id"]).then(() => {
            if (this.product) {
              this.productData.push(this.product);
            }
          })
        })
      }
      else {
        await OperationsStore.fetchAll({filter: {id: data}})
        this.formData = {}
        this.formData.products = OperationsStore.operations?.data![0].products
        this.formData.products.forEach((key: any) => {
          this.productById(key["product_id"]).then(() => {
            if (this.product) {
              this.productData.push(this.product);
            }
          })
        }) 
      }

    } catch (e) {
      console.error(e)
    } finally {
      this.summProducts = this.calcSum();
      this.formReady = true;
    }
  }
}
